import Delivery from './Delivery'
import './Delivery.css'

export default Delivery



// WEBPACK FOOTER //
// ./src/components/Delivery/index.js